<template>
  <div>
    <data-list :payload="listPayloadObj" v-model="pagination" :total="total" :pagination="pagination" :key="reRender">
      <template slot="additionButtons">
        <v-btn class="mx-2 info">{{ $t('message.common.sync') }}</v-btn>
      </template>
    </data-list>
    <v-dialog v-model="dialog" width="600" persistent>
      <form-template :references.sync="formReferences" :model="modelObj" ref="fieldsReference"></form-template>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import DataList from '@/components/DataList.vue'
import FormTemplate from '@/components/FormTemplate'
export default {
  data () {
    return {
      total: 0,
      dialog: false,
      modelObj: { isactive: true },
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        hideSearch: true,
        selection: [],
        showSelect: true,
        headers: [],
        list: [],
        loading: false,
        editProp: `${this.$i18n.locale}_name`,
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleRecordHandler
      },
      loading: false,
      pagination: !this.$format.isEmptyObject(this.$store.state.common.HOLIDAYS_INDEX) ? this.$store.state.common.HOLIDAYS_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'holidays',
      reRender: 0
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.common.name'),
        value: `${this.$i18n.locale}_name`,
        isRoute: true,
        isModal: true,
        width: '50%'
      }, {
        text: this.$t('message.common.date'),
        value: 'date',
        width: '40%'
      }]
    },
    ...mapGetters(['formType']),
    formReferences () {
      return {
        title: this.modelObj.id ? this.$t('message.common.updateHoliday') : this.$t('message.common.addHoliday'),
        properties: [{
          model: `${this.$i18n.locale}_name`,
          type: this.formType.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.common.name'),
          class: 'xs6'
        }, {
          model: 'date',
          rules: [],
          type: this.formType.DATEPICKER,
          class: 'sm6 xs12',
          picker: 'datePicker',
          menu: 'dateMenu',
          color: 'primary lighten-1',
          label: this.$t('message.common.date')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        let model = { type: 'HOLIDAYS_INDEX', data: val }
        this.$store.commit('rememberOrder', model)
        this.getListHandler()
      },
      deep: true
    },
    'modelObj.datePicker' (val) {
      if (val) {
        this.modelObj.date = this.$format.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    }
  },
  mounted () {
    this.$eventBus.$on('languageChanged', () => {
      this.listPayloadObj.editProp = `${this.$i18n.locale}_name`
      this.reRender++
    })
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        let payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE
      this.$api.execute('get', `${this.MODULE}`)
        .then((response) => {
          let holidaysList = response.data || []
          let transformData = { date: { list: ['date'], from: 'YYYY-MM-DDTHH:mm:ss', to: 'DD.MM.YYYY' } }
          holidaysList = this.$format.formatListModel(holidaysList, transformData)
          this.listPayloadObj.headers = this.headers
          this.listPayloadObj.loading = false
          this.listPayloadObj.list = holidaysList
          this.total = holidaysList.length
        })
    },
    getSingleRecordHandler (id) {
      this.modelObj = this.$format.cloneVariable(this.listPayloadObj.list.find(x => x.id === id))
      this.dialog = true
      /* this.$api.getSingleRecordHandler(`${this.MODULE}/${id}`)
        .then((result) => {
          if (result.data) this.modelObj = result.data
          this.dialog = true
        }) */
    },
    openDialogHandler () {
      this.dialog = true
    },
    closeDialogHandler () {
      this.loading = false
      this.dialog = false
      this.modelObj.id = undefined
      this.$refs.fieldsReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.fieldsReference.$refs.validateForm.validate()) {
        this.loading = true
        let transformData = { date: { list: ['date'], from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
        let model = this.$format.formatModel(this.modelObj, transformData)
        let url = this.MODULE
        this.$api.saveUpdateHandler(url, model)
          .then(() => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
            this.closeDialogHandler()
            this.getListHandler()
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
    this.$eventBus.$off('languageChanged')
  }
}
</script>
